import type { useTranslations } from 'next-intl';
import { REWARDS_TIERS } from '~/components/Account/Rewards/RewardsTiers.config';

type AccountTranslations = ReturnType<typeof useTranslations<'account'>>;
type JourneyTranslations = ReturnType<typeof useTranslations<'journey'>>;

type LoyaltyBenefitsCopyOptions = {
  discount: number;
  tier: string;
};

export const getLoyaltyBenefitsDescription = (
  t: JourneyTranslations,
  tierId: string | undefined,
  options: LoyaltyBenefitsCopyOptions
): string => {
  const tierConfigId = REWARDS_TIERS.find((tier) => tier.tierId === tierId)?.id;

  // Literal keys only — required by messages/validate-i18n-keys.mjs.
  switch (tierConfigId) {
    case 'expert':
      return t('loyalty_benefits_expert', options);
    case 'adventurer':
      return t('loyalty_benefits_adventurer', options);
    default:
      return t('loyalty_benefits_explorer', options);
  }
};

// Literal keys only — required by messages/validate-i18n-keys.mjs.
export const getLocalisedTierName = (
  tAccount: AccountTranslations,
  tierId: string | undefined,
  fallback: string
): string => {
  switch (REWARDS_TIERS.find((tier) => tier.tierId === tierId)?.id) {
    case 'explorer':
      return tAccount('rewards_tier_explorer_name');
    case 'adventurer':
      return tAccount('rewards_tier_adventurer_name');
    case 'expert':
      return tAccount('rewards_tier_expert_name');
    default:
      return fallback;
  }
};
